import { ExpressionType, IExpression } from '../IExpression';
import { IReference } from '../references/IReference';
import { IReferenceExpression } from '../repository/reference/IReferenceExpression';
import { ObjectsArrayFieldDatatype, isObjectsArrayField } from './Datatype';

export interface IReferenceExpressionObjectsArray extends IReferenceExpression {
  value: IReference & {
    field: ObjectsArrayFieldDatatype;
  };
}

export function isExpressionReferenceOfObjectsArray(
  expression: IExpression | null | undefined,
): expression is IReferenceExpressionObjectsArray {
  return (
    expression != null &&
    expression.type === ExpressionType.Reference &&
    expression.value?.field != null &&
    isObjectsArrayField(expression.value.field)
  );
}
